export const CHART_THEME = {
  styleSheet: {
    fontFamily: 'Aeonik, sans-serif',
  },
}

export const CASHFLOW_CHART_MONTHS_COUNT = 12
